import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const SsoTestModeBanner = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "sso-test-mode-banner" */ './hocs')),
});
